// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as DownloadComponent} from './Download.svg';

import Icon, { TIconProps } from '../Icon';

export const IconDownload = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <DownloadComponent/>
  </Icon>
));
